<dx-form #form [formData]="tracabilite" labelLocation="top" [readOnly]="!isModificationEnCours" height="auto">
  <dxi-item itemType="group" caption="Configurer la traçabilité">
    <dxi-item itemType="group" [colSpan]="2" [colCount]="2">
      <dxi-item dataField="dluo" [label]="{ text: 'DLUO' }" editorType="dxSelectBox"
        [editorOptions]="{
          dataSource: niveauObligations,
          searchEnabled: true,
          displayExpr: 'libelle',
          valueExpr: 'id',
          showClearButton: true,
          showDataBeforeSearch: true,
        }">
      </dxi-item>
      <dxi-item dataField="dlc" [label]="{ text: 'DLC' }" editorType="dxSelectBox"
        [editorOptions]="{
          dataSource: niveauObligations,
          searchEnabled: true,
          displayExpr: 'libelle',
          valueExpr: 'id',
          showClearButton: true,
          showDataBeforeSearch: true,
        }">
      </dxi-item>
      <dxi-item dataField="numeroLot" [label]="{ text: 'Numéro de lot' }" editorType="dxSelectBox"
        [editorOptions]="{
          dataSource: niveauObligations,
          searchEnabled: true,
          displayExpr: 'libelle',
          valueExpr: 'id',
          showClearButton: true,
          showDataBeforeSearch: true,
        }">
      </dxi-item>
      <dxi-item dataField="numeroSerie" [label]="{ text: 'Numéro de série' }" editorType="dxSelectBox"
        [editorOptions]="{
          dataSource: niveauObligations,
          searchEnabled: true,
          displayExpr: 'libelle',
          valueExpr: 'id',
          showClearButton: true,
          showDataBeforeSearch: true,
        }">
      </dxi-item>
    </dxi-item>
  </dxi-item>
</dx-form>